<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <input matInput [matDatepicker]="picker" [formControlName]="name" autocomplete="date" />
  <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if (description) {
    <mat-hint>
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>
